import Swal from "sweetalert2/dist/sweetalert2.js";

/*Tps-report*/
if (window.location.pathname.includes("admin/users")) {
    var options = {
        columnDefs: [
            {
                render: function(data, type, row) {
                    if (data == null || typeof data == "undefined") return data;
                    return "<a href='tel:" + data + "'>" + data + "</a>";
                },
                targets: [2]
            },
            {
                render: function(data, type, row) {
                    if (data == null || typeof data == "undefined") return data;
                    return "<a href='mailto:" + data + "'>" + data + "</a>";
                },
                targets: [1]
            },
            {
                render: function(data, type, row) {
                    if (data == null || typeof data == "undefined") {
                        return '<span class="text-success">Active</span>';
                    }
                    return '<span class="text-danger">Deleted</span>';
                },
                targets: [4]
            }
        ],
        iDisplayLength: -1
    };

    $.each($(".data-table"), function() {
        $(this).data("options", options);
    });

    $(window).on("dataTableInit.limelight", function(e, t) {
        $(".dataTables_wrapper").on("click", ".datatable-command", function() {
            const type = $(this).data("type");
            const id = $(this).data("id");

            switch (type) {
                case "reset2fa":
                    Swal.fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#ff1d25",
                        confirmButtonText: "Reset",
                        cancelButtonText: "Cancel",
                        reverseButtons: true,
                        heightAuto: false
                    }).then(result => {
                        if (result.isConfirmed) {
                            $.ajax({
                                url: "/api/user/reset-2fa",
                                method: "post",
                                data: { id },
                                dataType: "json",
                                success: function(response) {
                                    Swal.fire({
                                        title: "2FA Reset",
                                        text: response.message,
                                        heightAuto: false,
                                        icon: "success"
                                    });
                                }
                            });
                        }
                    });
                    break;
                default:
                    break;
            }
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/users.js